import {Component, h, Prop, EventEmitter, Element, Event, Host} from '@stencil/core';
import inputmask from 'inputmask';

let inputId = 0;

@Component({
  tag: 'nest-input',
  styleUrl: 'nest-input.scss',
  shadow: false,
})
export class NestInput {
  nativeInput?: HTMLInputElement

  private inputId = `nest-input-${inputId++}`

  @Element() el!: HTMLElement

  @Prop({ mutable: true, reflect: true }) value?: string = undefined

  @Prop() name: string = this.inputId;

  @Prop() label: string | null;

  @Prop() icon: string | null;

  @Prop() placeholder: string | null = 'Search value...';

  @Prop() type: string = 'text';

  @Prop() helper: string | null;

  @Prop({ reflect: true })
  public clearable: boolean = true;

  @Prop({ reflect: true })
  public isLoading: boolean = false;

  @Prop() mask?: string;

  @Event() nestInput!: EventEmitter<string | null>;

  onInput = (event: InputEvent) => {
    const input = this.getInputTarget(event);
    this.value = input.value;
    this.nestInput.emit(input.value);
  }

  clearInput = () => {
    this.value = null;
    this.nestInput.emit(null);
  }

  private getInputTarget(ev: Event): HTMLInputElement | null {
    return ev.target as HTMLInputElement | null
  }

  componentDidLoad(): void {
    if (this.mask) inputmask({"mask": this.mask}).mask(this.nativeInput);
  }

  render() {
    const { type,
      value,
      name,
      label,
      icon,
      placeholder,
      helper,
      inputId,
      clearable,
      isLoading
    } = this;

    return (
      <Host>
        <div class={{
          'nest-input': true,
          'nest-input--with-icon': !!icon,
        }}>
          {label &&
            <div class='nest-input__label'>{this.label}</div>
          }
          <div class='nest-input__control'>
            {icon &&
              <nest-icon name={icon} class="nest-input__control--icon"></nest-icon>
            }
            <input
              name={name}
              ref={inputEl => (this.nativeInput = inputEl)}
              value={value}
              onInput={this.onInput}
              placeholder={placeholder}
              id={inputId}
              type={type}
              class="p-1 px-2 bg-background appearance-none outline-none w-full"
              autocomplete='off'
            />

            {isLoading &&
              <nest-spinner class='nest-input__control--loading' size={'small'}></nest-spinner>
            }

            {clearable && value &&
              <nest-icon name="close-circle" onClick={this.clearInput} class="nest-input__control--clear"></nest-icon>
            }
          </div>
          {helper && <p class="nest-input__helper" innerHTML={helper}></p>}
        </div>
      </Host>
    );
  }
}
